<template>
  <v-container class="payment-widget">
    <v-row class="payment-widget-row">
      <v-col cols="12" xl="6" md="6" sm="12" class="payment-widget-col income">
        <v-subheader>{{ lang.orders.new.payment.income.title }}</v-subheader>
        <List
          v-model="payment.income"
          :debt="debt"
          cat="income"
        />
      </v-col>
      <v-col cols="12" xl="6" md="6" sm="12" class="payment-widget-col paid">
        <v-subheader>{{ lang.orders.new.payment.paid.title }}</v-subheader>
        <List
          v-model="payment.paid"
          :debt="debt"
          cat="paid"
        />
      </v-col>
    </v-row>
    <v-row class="payment-widget-footer">
      <v-col cols="6"></v-col>
      <v-col cols="6" class="prices">
        <v-row class="prices-row">
          <v-col cols="5" class="prices-col">
            <p>{{ lang.orders.new.payment.prices.total }}</p>
          </v-col>
          <v-col cols="7" class="prices-col">
            <p>{{ formatCurrency(income) }}</p>
          </v-col>
        </v-row>
        <v-row
          v-if="paid > 0"
          class="prices-row"
        >
          <v-col cols="5" class="prices-col">
            <p class="total green--text">{{ lang.orders.new.payment.prices.paid }}</p>
          </v-col>
          <v-col cols="7" class="prices-col">
            <p class="total green--text">{{ formatCurrency(paid) }}</p>
          </v-col>
        </v-row>
        <v-row
          v-if="debt > 0"
          class="prices-row"
        >
          <v-col cols="5" class="prices-col">
            <p class="total deep-orange--text">{{ lang.orders.new.payment.prices.debt }}</p>
          </v-col>
          <v-col cols="7" class="prices-col">
            <p class="total deep-orange--text">{{ formatCurrency(debt) }}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import List from './List'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { List },
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Object,
      default: () => {
        return { income: [], paid: [] }
      }
    },
    subtotal: {
      type: Number,
      default: 0
    },
    payments: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      payment: { ...this.value },
      update: 0
    }
  },
  computed: {
    income () {
      this.update
      let income = this.payment.income || [],
          discounts = this.payment.paid.filter(a => a.type <= 2) || [],
          total_i = income.reduce((acc, curr) => parseFloat((acc + curr.value).toFixed(2)), 0),
          total_d = discounts.reduce((acc, curr) => parseFloat((acc + (curr.type === 1 ? total_i * (curr.percent / 100) : curr.value)).toFixed(2)), 0)
      return parseFloat((total_i - total_d).toFixed(2))
    },
    paid () {
      this.update
      let paid = this.payment.paid.filter(a => a.type > 2 && (typeof a.delete === 'undefined' || a.delete < 1)) || []
      return paid.reduce((acc, curr) => parseFloat((acc + curr.value).toFixed(2)), 0) || 0
    },
    debt () {
      this.update
      return parseFloat((this.income - this.paid).toFixed(2))
    }
  },
  watch: {
    payment: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.value)) this.$emit('input', newVal)
        this.update++
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler () {
        this.getPayment()
        this.update++
      }
    },
    subtotal () {
      this.getPayment()
      this.update++
    },
    payments: {
      deep: true,
      handler () {
        setTimeout(function () {
          this.updatePayments()
        }.bind(this), 300)
      }
    },
    debt (newVal) {
      this.$emit('setPaid', (newVal === 0))
    }
  },
  methods: {
    updatePayments () {
      let list = this.payment.paid || [],
          payments = this.payments || []
      payments.map(pay => {
        let index = list.findIndex(a => a.id === pay.id),
            type = (pay.method + 2),
            option = (this.get_global.defaults.options.orders.payment.type || []).find(opt => opt.value === type) || false,
            new_ = {
              id: pay.id,
              UUID: this.getRandomUnique(),
              cat: 'paid',
              type,
              title: `${this.lang.orders.new.payment.paid.types.payment.title} ${(option ? '(' + option.text + ')' : '')}`,
              percent: 10,
              value: pay.value,
              tax: pay.taxes,
              parcels: pay.parcels,
              delete: 0
            }
        if (index >= 0) list.splice(index, 1)
        list.push({ ...new_ })
      })
      this.payment.paid = [ ...list ]
      // this.$set(this, 'payment.paid', list)
    },
    setSubtotal (income) {
      let subtotal = this.subtotal || 0,
          rtrn = income.filter(inc => inc.type !== 0) || [],
          new_ = { ...defaults.blank.payment }
      new_.UUID = 0
      new_.type = 0
      new_.title = this.lang.orders.new.payment.income.subtotal
      new_.value = subtotal
      rtrn.unshift(new_)
      return [ ...rtrn ]
    },
    setPercentValues (income, paid) {
      let total_i = (income || []).reduce((acc, curr) => parseFloat((acc + curr.value).toFixed(2)), 0),
          rtrn = paid.map((paid_) => {
            if (paid_.type === 1 && paid_.percent > 0) {
              paid_.value = total_i * (paid_.percent / 100)
            }
            return paid_
          })
      return [ ...rtrn ]
    },
    getPayment () {
      let value = { ...this.value },
          income = this.setSubtotal(value.income),
          paid = this.setPercentValues(income, value.paid)
      value.income = [ ...income ]
      value.paid = [ ...paid ]
      return this.$set(this, 'payment', value)
    }
  },
  created () {
    this.getPayment()
    this.updatePayments()
  }
}
</script>

<style src="./styles/index.scss" lang="scss"/>